export const infracaoMotoristaFormStructure = [
  [
    {
      name: 'id',
      label: 'Id',
      component: 'FormField',
      type: 'number',
      colProps: { md: 2 },
      readOnly: true,
      disabled: true
    },
    {
      name: 'cpfMotorista',
      label: 'CPF Motorista',
      component: 'FormField',
      type: 'text',
      colProps: { md: 4 },
      maxLength: 14
    },
    {
      name: 'mesFechamento',
      label: 'Mes Fechamento',
      component: 'FormField',
      type: 'number',
      colProps: { md: 2 }
    },
    {
      name: 'anoFechamento',
      label: 'Ano Fechamento',
      component: 'FormField',
      type: 'number',
      colProps: { md: 2 }
    },
    {
      name: 'idInfracao',
      label: 'Id Infracao',
      component: 'FormField',
      type: 'number',
      colProps: { md: 2 },
      readOnly: true,
      disabled: true
    }
  ]
];

export const infracaoMotoristaFormSections = () => [
  { title: 'Infracao do Motorista', rows: [0] }
];

export const validateInfracaoMotoristaForm = () => ({});

export const emptyInfracaoMotoristaForm = {
  id: '',
  cpfMotorista: '',
  mesFechamento: '',
  anoFechamento: '',
  idInfracao: ''
};
